import DecoratedLink from '@js/DecoratedLink'

/**
 * Searches for href="tel:" links and adds screen-reader text and an icon.
 *
 * @extends DecoratedLink
 */
class TelLink extends DecoratedLink {
    constructor(element) {
        super(element, {
            iconName: 'fa-mobile-screen',
            iconStyle: 'fa-solid',
            classSuffix: 'tel',
            srMessage: 'interact to call this phone number'
        })

        if (sir.isEditor) return
    }
}

TelLink.create('a[href^="tel:"]')
